module.exports = __webpack_public_path__ + "static/classhook-goals-a472bb51155cc4d1ff71be3e1090eb83.png";